<template>
  <div class="blob-container" @click="show">
    <v-icon>
      mdi-information-outline
    </v-icon>
    <div class="blob-text">
      Ladda ner Livet i havet till din telefon. Klicka här för att se hur man
      gör!
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    show() {
      this.$router.push({ name: 'Video' })
    }
  }
}
</script>

<style lang="scss" scoped>
.blob-container {
  z-index: 4;
  position: absolute;
  width: 200px;
  height: 100px;
  padding: 10px;
  display: flex;
  cursor: pointer;
  background-color: rgb(254, 226, 89) !important;
  align-items: center;
}

.blob-text {
  font-size: 14px;
  color: #000;
  margin-left: 10px;
}
@media screen and (max-width: 975px) {
  .blob-container {
    display: none;
  }
}
</style>
